export default "__VITE_ASSET__CpQf3Yxn__"